import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PostAddIcon from "@mui/icons-material/PostAdd";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import Confirm from "../../components/Confirm";

import CoursesGroupItem from "./CoursesGroupItem";

import { getGroupsCourses, deleteCoursesGroupById } from "../../api/coursesGroups";

const CoursesGroupsTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [groups, setGroups] = useState([]);
  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedOperationId(id);
    setIsDeleteModalShow(true);
  }
  function onEdit(id) {
    history.push(`${match.path}/${id}`);
  }
  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteCoursesGroupById(selectedOperationId);
    }
    setIsDeleteModalShow(false);

    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const newGroups = await getGroupsCourses();
      setGroups(newGroups);
    })();
  }, [refresh]);

  return (
    <>
      <h2>{t("course_groups.title")}</h2>
      <TableComponent
        TopComponent={
          <Button size="small" onClick={() => history.push(`${match.path}/add_courses_group`)}>
            <PostAddIcon />
            {t("course_groups.add_courses_group")}
          </Button>
        }
        header={[
          { title: t("id"), sort: "id", style: { width: "5%" } },
          { title: t("course_groups.group_name"), sort: "groupName" },
          { title: t("course_groups.related_courses") },
          { title: t("actions") },
        ]}
        renderChildren={(group) => (
          <CoursesGroupItem key={group.id} onDelete={showDeleteModal} onEdit={onEdit} group={group} />
        )}
        items={groups}
        search={["groupName", "id"]}
        pagination
      />
      {isDeleteModalShow && selectedOperationId ? (
        <Confirm title={t("course_groups.delete_action")} onConfirm={confirmDeleteModal}>
          <p>{t("course_groups.delete_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default CoursesGroupsTable;
